import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Space,
} from "antd";
import moment from "moment";

function BatteryModal({
  open = false,
  onSave = () => {},
  onCancel = () => {},
  data = {},
  isUpdate = false,
}) {
  return (
    <Modal
      title={isUpdate ? "Update Battery" : "Add Battery"}
      centered
      width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        layout="vertical"
        onFinish={(values) => {
          onSave(values);
        }}
        initialValues={
          Object.keys(data).length
            ? {
                ...data,
                mfg_date: data.mfg_date ? moment(data.mfg_date) : null,
                valid_till: data.valid_till ? moment(data.valid_till) : null,
              }
            : {
                is_active: true,
              }
        }
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Battery Number"
              name="battery_number"
              rules={[
                {
                  required: true,
                  message: "Please input Battery Number",
                },
              ]}
            >
              <Input placeholder="Battery Number" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Type"
              name="type"
              rules={[
                {
                  required: true,
                  message: "Please input Type",
                },
              ]}
            >
              <Input placeholder="Type" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item label="MFG Date" name={"mfg_date"}>
              <DatePicker placeholder="MFG Date" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="IMEI Number"
              name={"imei_number"}
              rules={[
                {
                  required: true,
                  message: "Please input IMEI Number",
                },
              ]}
            >
              <Input placeholder="IMEI Number" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Status"
              name="is_active"
              rules={[
                {
                  required: true,
                  message: "Please select Status",
                },
              ]}
            >
              <Radio.Group>
                <Radio value={true}>Active</Radio>
                <Radio value={false}> In-Active </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Valid till" name={"valid_till"}>
              <DatePicker placeholder="Valid till" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {isUpdate ? "Save" : "Add"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default BatteryModal;
